/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RatelimitDeleteOverrideResponseData = {};

/** @internal */
export const RatelimitDeleteOverrideResponseData$inboundSchema: z.ZodType<
  RatelimitDeleteOverrideResponseData,
  z.ZodTypeDef,
  unknown
> = z.object({});

/** @internal */
export type RatelimitDeleteOverrideResponseData$Outbound = {};

/** @internal */
export const RatelimitDeleteOverrideResponseData$outboundSchema: z.ZodType<
  RatelimitDeleteOverrideResponseData$Outbound,
  z.ZodTypeDef,
  RatelimitDeleteOverrideResponseData
> = z.object({});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace RatelimitDeleteOverrideResponseData$ {
  /** @deprecated use `RatelimitDeleteOverrideResponseData$inboundSchema` instead. */
  export const inboundSchema =
    RatelimitDeleteOverrideResponseData$inboundSchema;
  /** @deprecated use `RatelimitDeleteOverrideResponseData$outboundSchema` instead. */
  export const outboundSchema =
    RatelimitDeleteOverrideResponseData$outboundSchema;
  /** @deprecated use `RatelimitDeleteOverrideResponseData$Outbound` instead. */
  export type Outbound = RatelimitDeleteOverrideResponseData$Outbound;
}

export function ratelimitDeleteOverrideResponseDataToJSON(
  ratelimitDeleteOverrideResponseData: RatelimitDeleteOverrideResponseData,
): string {
  return JSON.stringify(
    RatelimitDeleteOverrideResponseData$outboundSchema.parse(
      ratelimitDeleteOverrideResponseData,
    ),
  );
}

export function ratelimitDeleteOverrideResponseDataFromJSON(
  jsonString: string,
): SafeParseResult<RatelimitDeleteOverrideResponseData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      RatelimitDeleteOverrideResponseData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RatelimitDeleteOverrideResponseData' from JSON`,
  );
}
